var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92 -887)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(92 887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427,2706v-2a3,3,0,0,0-3-3h-8a3,3,0,0,0-3,3v2a1,1,0,0,1-2,0v-2a5,5,0,0,1,5-5h8a5,5,0,0,1,5,5v2a1,1,0,0,1-2,0Zm-12-14a5,5,0,1,1,5,5A5,5,0,0,1,415,2692Zm2,0a3,3,0,1,0,3-3A3,3,0,0,0,417,2692Z",
    transform: "translate(-411 -2687)",
    fill: "#c2c4d4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/Perfil.80cd3d049ce93ff09bfbd404697afb0f.svg";
export { ForwardRef as ReactComponent };